"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextCell = void 0;
const getNextCell = (cellsMap, idIndexMap, id, key) => {
    var _a;
    const lastRowIndex = cellsMap.length - 1;
    const lastColumnIndex = cellsMap[lastRowIndex].length - 1;
    const { row, column } = idIndexMap[id];
    const nextStateByKey = {
        ArrowDown: [row + 1, column],
        ArrowUp: [row - 1, column],
        ArrowRight: [row, column + 1],
        ArrowLeft: [row, column - 1],
        Home: [0, 0],
        End: [lastRowIndex, lastColumnIndex],
    };
    const [nextRow, nextColumn] = nextStateByKey[key];
    return (_a = cellsMap[nextRow]) === null || _a === void 0 ? void 0 : _a[nextColumn];
};
exports.getNextCell = getNextCell;
//# sourceMappingURL=getNextCell.js.map